import { render, staticRenderFns } from "./PhoneDetails.vue?vue&type=template&id=064d6fe1&scoped=true&"
import script from "./PhoneDetails.vue?vue&type=script&lang=js&"
export * from "./PhoneDetails.vue?vue&type=script&lang=js&"
import style0 from "./PhoneDetails.vue?vue&type=style&index=0&id=064d6fe1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d6fe1",
  null
  
)

export default component.exports